export function buildQuery(query: any): string {
    const params = new URLSearchParams();

    if (query.q && query.q.trim()) params.set("q", query.q.trim());
    if (query.sort) params.set("sort", query.sort); 
    if (query.blogCategoryId) params.set("blogCategoryId", String(query.blogCategoryId));
    if (query.featuredOnly) params.set("featuredOnly", String(query.featuredOnly));
    if (query.page && query.page > 0) params.set("page", String(query.page));
    if (query.pageSize && query.pageSize > 0)
        params.set("pageSize", String(query.pageSize));

    return params.toString();
}
